'use strict';

wbApp.controller('ActivityReconciliationReconciliationCtrl', ['$scope', '$modal', '$q', '$window', 'activityReconciliationSvc',
function ($scope, $modal, $q, $window, activityReconciliationSvc) {

    $scope.reconciliation = [];

    $scope.semesterID = null;
    $scope.activityID = null;
    $scope.studentID = null;
    $scope.studentFullName = null;

    var isActivite = false;
    var loaded = false;

    function reloadData() {
        if (isActivite) {
            if ($scope.activityID && $scope.studentID) {
                $scope.reconciliation = activityReconciliationSvc.getByStudentAndActivity(
                    $scope.semesterID,
                    $scope.activityID,
                    $scope.studentID);
                loaded = true;
            } else {
                loaded = false;
                $scope.reconciliation = [];
            }
        }
    }

    $scope.$on('activityReconciliationDetailSaved', function (e, data) {
        reloadData();
        $scope.$emit('activityReconciliationChanged', { studentID: $scope.studentID });
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 2) {
            if (!isActivite) {
                isActivite = true;
                if (!loaded) {
                    reloadData();
                }
            }
        } else {
            isActivite = false;
        }
    });

    $scope.$on('activityStudentSelectionChanged', function (e, data) {
        if (data.studentID != $scope.studentID ||
            data.activityID != $scope.activityID) {
            $scope.semesterID = data.semesterID;
            $scope.activityID = data.activityID;
            $scope.studentID = data.studentID;
            $scope.studentFullName = data.studentFullName;

            if (isActivite) {
                reloadData();
            } else {
                loaded = false;
            }
        } else {
            $scope.reconciliation.length = 0;
        }
    });

    $scope.acivityReconciliationReconciliationFilterOptions = {
        filterText: ""
    };

    $scope.acivityReconciliationReconciliationGridOptions = {
        sortInfo: { fields: ['reconciledAt'], directions: ['asc'] },
        columnDefs: [
            { field: 'reconciledAt', cellFilter: "date:'shortDate'", displayName: "TXT_LBL_DATE", width: '90px' },
            { field: 'name', width: '250px', displayName: "TXT_LBL_NAME" },
            { field: 'notes', displayName: "TXT_LBL_NOTE" },
            { field: 'debit', displayName: "TXT_LBL_PRICE", width: '90px', cellFilter: 'wbCurrencyFlt', align: 'right' },
            { field: 'credit', displayName: "TXT_LBL_PAYMENTS", width: '90px', cellFilter: 'wbCurrencyFlt', align: 'right' },
            { field: 'notificationSentAt', displayName: "Oznámení", width: '110px', cellFilter: "date:'short'" },
        ],
        customCmds: [
            {
                text: 'TXT_MENU_PRINT_INVOICE',
                hide: function (selected) { return !selected || !selected.invoiceID; },
                command: function (row) { $scope.onPrintInvoice(row); }
            }, {
                text: 'TXT_MENU_SEND_RECONCILIATION_INFO',
                hide: function (selected) { return !selected || !selected.invoiceID; },
                command: function (row) { $scope.onSendReconciliationInfo(row); }
            }]
    };

    $scope.onRowDelete = function (row) {
        activityReconciliationSvc.deleteReconciliationDetail(
            $scope.activityID,
            $scope.studentID,
            row.activityReconciliationID,
            success);

        function success() {
            reloadData();
        }
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.activityReconciliationID = null;
            detailDialogPromise.show();
        });
    }

    $scope.onRowEdit = function (row) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.activityReconciliationID = row.activityReconciliationID;
            detailDialogPromise.show();
        });
    }

    $scope.onPrintInvoice = function (row) {
        $window.open('/Admin/Report/Invoice?ReportID=' + row.invoiceID + '&ReportIDType=1',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');

    }

    $scope.onSendReconciliationInfo = function (row) {
        activityReconciliationSvc.sendReconciliationNotification(
            $scope.activityID,
            $scope.studentID,
            row.activityReconciliationID,
            row.invoiceID,
            success);

        function success() {
            reloadData();
        }
    }

    var detailDialogPromise = $modal({
        templateUrl: 'activities/activity-reconciliation-detail.html',
        show: false,
        scope: $scope.$new()
    });


}]);